import Dashboard from "./layouts/dashboard";

import ArticleList from "./layouts/article/data";
import ArticleEditor from "./layouts/article/new";
import ArticleDetails from "./layouts/article/details";
import UserList from "./layouts/user/data";
import UserNew from "./layouts/user/new"
import AuthorList from "./layouts/author/data";
import AuthorNew from "./layouts/author/new"
import AuthorDetails from "./layouts/author/details"
import SectionList from "./layouts/section/data";
import SectionNew from "./layouts/section/new"
import SectionDetails from "./layouts/section/details"
import InstitutionList from "./layouts/institution/data";
import InstitutionNew from "./layouts/institution/new"
import InstitutionDetails from "./layouts/institution/details"
import AdList from "./layouts/ads/data";
import AdNew from "./layouts/ads/new"
import AdDetails from "./layouts/ads/details"
import NewsletterList from "./layouts/newsletter/data";
import NewsletterNew from "./layouts/newsletter/new"
import NewsletterDetails from "./layouts/newsletter/details";
import LogList from "./layouts/log/data";
import LogDetails from "./layouts/log/details"
import Profile from "./layouts/profile";
import SignIn from "./layouts/authentication/sign-in";

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Artículos",
    key: "articles",
    icon: <Icon fontSize="small">article</Icon>,
    route: "/articles",
    component: <ArticleList />,
  },
  {
    key: "new-article",
    route: "/articles/new",
    component: <ArticleEditor />,
  },
  {
    key: "edit-article",
    route: "/articles/edit/:id",
    component: <ArticleEditor />,
  },
  {
    key: "details-article",
    route: "/articles/details/:id",
    component: <ArticleDetails />,
  },
  {
    type: "collapse",
    name: "Usuarios",
    key: "users",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/users",
    component: <UserList />,
    role: "admin",
  },
  {
    key: "new-user",
    route: "/users/new",
    component: <UserNew />,
    role: "admin",
  },
  {
    key: "edit-user",
    route: "/users/edit/:id",
    component: <UserNew />,
    role: "admin",
  },
  {
    type: "collapse",
    name: "Autores",
    key: "authors",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/authors",
    component: <AuthorList />,
    role: "admin",
  },
  {
    key: "new-author",
    route: "/authors/new",
    component: <AuthorNew />,
    role: "admin",
  },
  {
    key: "edit-author",
    route: "/authors/edit/:id",
    component: <AuthorNew />,
    role: "admin",
  },
  {
    key: "details-author",
    route: "/authors/details/:id",
    component: <AuthorDetails />,
    role: "admin",
  },
  {
    type: "collapse",
    name: "Secciones",
    key: "sections",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/sections",
    component: <SectionList />,
    role: "admin",
  },
  {
    key: "new-section",
    route: "/sections/new",
    component: <SectionNew />,
    role: "admin",
  },
  {
    key: "edit-section",
    route: "/sections/edit/:id",
    component: <SectionNew />,
    role: "admin",
  },
  {
    key: "details-section",
    route: "/sections/details/:id",
    component: <SectionDetails />,
    role: "admin",
  },
  {
    type: "collapse",
    name: "Instituciones",
    key: "institutions",
    icon: <Icon fontSize="small">account_balance</Icon>,
    route: "/institutions",
    component: <InstitutionList />,
    role: "admin",
  },
  {
    key: "new-institution",
    route: "/institutions/new",
    component: <InstitutionNew />,
    role: "admin",
  },
  {
    key: "edit-institution",
    route: "/institutions/edit/:id",
    component: <InstitutionNew />,
    role: "admin",
  },
  {
    key: "edit-institution",
    route: "/institutions/details/:id",
    component: <InstitutionDetails />,
    role: "admin",
  },
  {
    type: "collapse",
    name: "Anuncios",
    key: "ads",
    icon: <Icon fontSize="small">campaign</Icon>,
    route: "/ads",
    component: <AdList />,
    role: "admin",
  },
  {
    key: "new-ad",
    route: "/ads/new",
    component: <AdNew />,
    role: "admin",
  },
  {
    key: "edit-ad",
    route: "/ads/edit/:id",
    component: <AdNew />,
    role: "admin",
  },
  {
    key: "details-ad",
    route: "/ads/details/:id",
    component: <AdDetails />,
    role: "admin",
  },
  {
    type: "collapse",
    name: "Newsletter",
    key: "newsletters",
    icon: <Icon fontSize="small">email</Icon>,
    route: "/newsletters",
    component: <NewsletterList />,
    role: "admin",
  },
  {
    key: "new-newsletter",
    route: "/newsletters/new",
    component: <NewsletterNew />,
    role: "admin",
  },
  {
    key: "edit-newsletter",
    route: "/newsletters/edit/:id",
    component: <NewsletterNew />,
    role: "admin",
  },
  {
    key: "details-newsletter",
    route: "/newsletters/details/:id",
    component: <NewsletterDetails />,
    role: "admin",
  },
  {
    type: "collapse",
    name: "Auditoría",
    key: "logs",
    icon: <Icon fontSize="small">email</Icon>,
    route: "/logs",
    component: <LogList />,
    role: "admin",
  },
  {
    key: "details-log",
    route: "/logs/details/:id",
    component: <LogDetails />,
    role: "admin",
  },
  {
    type: "collapse",
    name: "Perfil",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
  },
  {
    type: "collapse",
    name: "Cerrar sesión",
    key: "sign-out",
    icon: <Icon fontSize="small">logout</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "divider",
    key: "divider-1",
  },
];

export default routes;